__turbopack_context__.v({
  "article-wrapper": "-Upfkq_article-wrapper",
  "desc": "-Upfkq_desc",
  "title": "-Upfkq_title",
  "viewMore": "-Upfkq_viewMore",
});
